import { OscillometryTestAcceptabilitySummary, TestResults } from '../../PulmonaryFunctionTests/Shared/PFTAPITypes';
import { ParameterTypeName } from './ParameterTypes';

export function MapOscillometryTestAcceptabilitySummaries(testResults: TestResults[]): Array<OscillometryTestAcceptabilitySummary> {
    return testResults.map(tr => {
        return {
            Accepted: tr.OverreaderAcceptability,
            TestId: tr.TestId,
            Ax: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_AX).Value?.toFixed(2),
            R5: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_R5).Value?.toFixed(2),
            R20: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_R20).Value?.toFixed(2),
            R5R20: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_R520).Value?.toFixed(2),
            R7: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_R7).Value?.toFixed(2),
            R7R20: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_R720).Value?.toFixed(2),
            X5: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_X5).Value?.toFixed(2),
            Fres: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_FRES).Value?.toFixed(2),
            Vt: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_VT).Value?.toFixed(2),
        } as OscillometryTestAcceptabilitySummary;
    });
}

